const font = {
    regular: "'Roboto Regular', Arial, Helvetica, sans-serif",
    bold: "'Roboto Bold', Arial, Helvetica, sans-serif",
    medium: "'Roboto Medium', Arial, Helvetica, sans-serif",
    light: "'Roboto Light', Arial, Helvetica, sans-serif",
    black: "'Roboto Black', Arial, Helvetica, sans-serif",
    VodafoneRg: "'VodafoneRg', Arial, Helvetica, sans-serif",
    VodafoneBd: "'VodafoneBd', Arial, Helvetica, sans-serif",
    VodafoneExB: "'VodafoneExB', Arial, Helvetica, sans-serif"
}

export default font;